import { render, staticRenderFns } from "./teamAdd.vue?vue&type=template&id=4c530caf"
import script from "./teamAdd.vue?vue&type=script&lang=js"
export * from "./teamAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports